import React from "react";
import { Box, Container, Paper, Typography } from "@mui/material";
import { CheckCircle } from "lucide-react";

function ThankYouPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#ffffff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={6}
          sx={{
            p: 4,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          <Box sx={{ mb: 3 }}>
            <CheckCircle
              size={80}
              color="#4CAF50"
              style={{
                backgroundColor: "white",
                borderRadius: "50%",
                padding: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              }}
            />
          </Box>

          <Typography
            variant="h3"
            sx={{
              mb: 2,
              fontFamily: "Times New Roman",
              fontWeight: "bold",
              textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            }}
          >
            Thank You!
          </Typography>

          <Typography
            variant="h6"
            sx={{
              fontFamily: "Times New Roman",
              opacity: 0.9,
            }}
          >
            Your Asset Undertaking Form has been submitted successfully
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default ThankYouPage;
